import React from 'react';
import AlertIcon from '../../_styles/images/AlertIcon.png';
import Callable from '../../shared/Callable';
import { connect } from 'react-redux';
import ArrowLeft from '../../_styles/images/ArrowLeft.png';
import { Link } from 'react-router-dom';
import analyticsService from '../../shared/analytics/analytics-service';

function FedmilPageRecuring(props) {

    function addSecondaryCard() {
        analyticsService.analyticsProcessEvent({
            "event": "click_generic",
            "context": {
              "event_action": "add secondary card"
            }
          });
        props.history.push({
            pathname: '/JoinCommute/add-payment/backup',
            state: { fromRecurring: true }
          });
    }
    return (
        <div className='fedmil-container'>

            <div className="main-container">
                <div className='green-header'>
                    <div className='backArrow'>
                        <Link className="overview-link" onClick={props.history.goBack}>
                            <img alt='go back' src={ArrowLeft}></img>
                        </Link>
                    </div>
                </div>
                <div className='main-content'>
                    <div className='header'>
                        <div className='alert-image'>
                            <img src={AlertIcon} alt='alert' />
                        </div>
                        <div className='heading'>
                            {
                                "Your cost exceeds the maximum authorized amount on your benefit card"
                            }
                        </div>
                    </div>
                    <div className='fedmil-content'>
                        <div className='content'>
                            <div className='first-section'>
                                {
                                    "To proceed please add a secondary payment card to cover the recurring subscription cost."
                                }
                            </div>
                        </div>
                        <div className="pre-text">
                            If you need help, please call <Callable className="greentext" phone="800 VAN 4 WORK" />
                        </div>
                    </div>
                    <div className='button-container'>
                        {
                            <button tabIndex={0} className="primarySecondaryCard" onClick={addSecondaryCard}>Add Secondary Card</button>
                        }

                    </div>
                </div>


            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        joinCommuteData: state.joinCommute,
        selectedVan: state.joinCommute.selectedVan,
        summaryData: state.joinCommute.userCommuteData.summaryData
    }
}

export default connect(mapStateToProps, null)(FedmilPageRecuring)